import { PDF_COLORS, PDF_FONTS, PDF_LAYOUT } from "./pdfStyles";

export const asText = (v, fallback = "") => {
  if (v === null || v === undefined) return fallback;
  const s = String(v).trim();
  return s === "" ? fallback : s;
};

export const asBool = (v) => {
  if (v === true) return true;
  if (v === false || v === null || v === undefined) return false;
  if (v === 1 || v === "1") return true;
  if (v === 0 || v === "0") return false;
  const s = String(v).trim().toLowerCase();
  return ["si", "sí", "true", "x", "checked"].includes(s);
};

export const asCheckText = (v) => (asBool(v) ? "SÍ" : "NO");

export const ensureSpace = (doc, currentY, neededHeight, onNewPage = null) => {
  const limit = PDF_LAYOUT.pageHeight - PDF_LAYOUT.marginBottom;
  if (currentY + neededHeight <= limit) {
    return currentY;
  }
  doc.addPage();
  const nextY = PDF_LAYOUT.marginTop;
  if (typeof onNewPage === "function") {
    return onNewPage(doc, nextY);
  }
  return nextY;
};

export const drawSectionHeader = (doc, title, y, iconLetter = null) => {
  const x = PDF_LAYOUT.marginX;
  const w = PDF_LAYOUT.contentWidth;
  const h = 18;

  // Background banner
  doc.setFillColor(...PDF_COLORS.bgLight);
  doc.setDrawColor(...PDF_COLORS.border);
  doc.rect(x, y, w, h, "FD");

  // Left primary accent bar
  doc.setFillColor(...PDF_COLORS.primary);
  doc.rect(x, y, 4, h, "F");

  // Section title text
  doc.setFont(PDF_FONTS.family, "bold");
  doc.setFontSize(PDF_FONTS.sizes.section);
  doc.setTextColor(...PDF_COLORS.primaryDark);
  doc.text(String(title || "").toUpperCase(), x + 10, y + 12.5);

  return y + h + 6;
};

export const drawTableGrid = (doc, rows, startY, options = {}) => {
  const x = options.x || PDF_LAYOUT.marginX;
  const w = options.w || PDF_LAYOUT.contentWidth;
  const colWidths = options.colWidths || [];
  const rowHeight = options.rowHeight || 17;
  let cy = startY;

  rows.forEach((row, rIdx) => {
    cy = ensureSpace(doc, cy, rowHeight);
    let cx = x;

    const isHeader = !!row.isHeader;
    const bg = isHeader ? PDF_COLORS.bgLight : rIdx % 2 === 0 ? PDF_COLORS.white : [250, 250, 252];
    doc.setFillColor(...bg);
    doc.setDrawColor(...PDF_COLORS.borderLight);
    doc.rect(x, cy, w, rowHeight, "FD");

    row.cells.forEach((cell, cIdx) => {
      const cw = colWidths[cIdx] || w / row.cells.length;
      const isBold = isHeader || !!cell.bold;
      const align = cell.align || "left";

      doc.setFont(PDF_FONTS.family, isBold ? "bold" : "normal");
      doc.setFontSize(cell.fontSize || (isHeader ? PDF_FONTS.sizes.label : PDF_FONTS.sizes.value));
      doc.setTextColor(...(cell.color || (isBold ? PDF_COLORS.textDark : PDF_COLORS.textMuted)));

      const text = asText(cell.text, "-");
      const textY = cy + rowHeight - 5.5;

      if (align === "right") {
        doc.text(text, cx + cw - 6, textY, { align: "right" });
      } else if (align === "center") {
        doc.text(text, cx + cw / 2, textY, { align: "center" });
      } else {
        doc.text(text, cx + 6, textY);
      }

      cx += cw;
    });

    cy += rowHeight;
  });

  return cy + 6;
};
